// extracted by mini-css-extract-plugin
module.exports = {"button":"GlobalSearch_button__2nWe6","content":"GlobalSearch_content__QZCxO"};